import {Lock} from 'lucide-react';
import {useNavigate} from 'react-router-dom';
import {PortalShell} from '../../shared/ui';

/** Quem abre pelo endereço uma área do portal sem ter a visão dela (BBF-175). */
export default function SemAcessoPage({erro = false}) {
    const navigate = useNavigate();
    const titulo = erro ? 'Não foi possível conferir o seu acesso' : 'Você não tem acesso a esta área do portal';
    const texto = erro
        ? 'Recarregue a página para tentar de novo.'
        : 'Se você precisa dela, peça acesso ao administrador da sua empresa.';

    return (
        <PortalShell>
            <div className="bf-page">
                <div className="bf-card" style={{maxWidth: 760}}>
                    <div className="bf-card__body">
                        <div className="bf-stack-3">
                            <div className="bf-row" style={{gap: 12}}>
                                <div className="bf-kpi-icon"><Lock size={24} /></div>
                                <h1 className="bf-section-title" style={{margin: 0}}>{titulo}</h1>
                            </div>
                            <p className="bf-muted" style={{margin: 0}}>{texto}</p>
                            <div>
                                <button className="bf-button bf-button--primary bf-button--sm" onClick={() => navigate('/')}>Voltar ao início</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PortalShell>
    );
}
